import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import {SessionStorageService} from 'ngx-webstorage';
import { Title } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-exito-agendamiento',
  templateUrl: './exito-agendamiento.component.html',
  styleUrls: ['./exito-agendamiento.component.scss']
})
export class ExitoAgendamientoComponent implements OnInit {
  direccion = {"Santiago":'El Regidor 54, Las Condes (Metro El Golf)',"Rancagua":'Pedro de Valdivia N°100',"Osorno":'Francisco Bilbao 1176',"Puerto Montt":'Benavente 867'}[this.storage && this.storage.retrieve('agendamiento') ?this.storage.retrieve('agendamiento').sucursal:""]+", "+(this.storage && this.storage.retrieve('agendamiento') ?this.storage.retrieve('agendamiento').sucursal:"");
  email= this.storage && this.storage.retrieve('agendamiento') ? this.storage.retrieve('agendamiento').email : "";
  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);

  constructor(
    private storage:SessionStorageService,
    private titleService: Title,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Agendamiento de Hora - Centro de Ayuda');
    if (this.isBrowser) {
      if (environment.production) {
        this.gtmService.addGtmToDom();
      }
    }
  }

  irHome() {
    location.href="./home";
  }
}
